import React from 'react'
import { ScrollView } from 'react-native'

import { Page } from 'partials/Page'
import { ReferralView } from 'partials/ReferralView'

import { Separator } from 'widgets/Separator'

import { useCurrentUser } from 'hooks/useCurrentUser'

export const ShareProfilePage = ({ navigation }) => {
  const user = useCurrentUser()

  return (
    <Page
      withBack
      withNav
      backgroundColor='white'
      title={`${user.data?.firstName} ${user.data?.lastName}`}
      navigation={navigation}
    >
      <Separator />
      <ScrollView>
        <ReferralView user={user.data!} />
      </ScrollView>
    </Page>
  )
}
